import { useField } from 'formik';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input as InputBootstrap
} from 'reactstrap';

import Icon from '@/components/common/icon';
import { Editor, Input, Autocomplete } from '@/components/form';
import DuplicateCalculations from '@/components/reports/duplicate-calculations';
import getResource from '@/services/resources';
import { t } from '@/services/translator';

import Calculations from './calculations';
import DataView from './data-view';

const Index = ({ index, getFieldHelpers, removeHandler, cloneHandler, calcHandler }) => {
  const [nameField] = useField({ name: `instances[${index}].name` });
  const [typeField] = useField({ name: `instances[${index}].type` });
  const [calcField] = useField({ name: `instances[${index}].calculations` });
  const [open, setOpen] = useState(false);
  const [tags, setTags] = useState();

  const loadTags = () => {
    getResource('Tag')
      .loadAll()
      .then((data) => {
        const options = data['hydra:member'].map((tag) => ({
          value: tag['@id'],
          label: t(tag.names?.fr || tag.alias)
        }));
        setTags(options);
      });
  };

  useEffect(() => {
    loadTags();
  }, []);

  return (
    <Row>
      <Col sm="12">
        <Button
          color="transparent"
          className={`bg-transparent ${!open ? 'text-info' : ''}`}
          onClick={() => setOpen(!open)}
        >
          <span className="mr-1">
            <Icon name={`chevron-${open ? 'down' : 'up'}`} />{' '}
          </span>
          {t('adminapp_instance_number')} - {index} {nameField.value ? `(${nameField.value})` : null}
        </Button>
      </Col>
      {open && (
        <Col sm="12">
          <Card className="mt-2 bg-wever-light">
            <CardBody>
              <Row className="m-0">
                <Col className="col-12 d-flex justify-content-end">
                  <div className="border-bottom">
                    <Button color="transparent" className="mr-1" title="clone" disabled>
                      <Icon name="download" />
                    </Button>
                    <DuplicateCalculations calculations={calcField.value} type={typeField.value} tags={tags} />
                    <Button color="transparent" className="mr-1" title="calc" onClick={calcHandler}>
                      <Icon name="sync" />
                    </Button>
                    <Button color="transparent" className="text-danger" onClick={removeHandler}>
                      <Icon name="trash" />
                    </Button>
                  </div>
                </Col>
                <Col lg={6}>
                  <Input name={`instances[${index}].name`} />

                  <Autocomplete
                    name={`instances[${index}].type`}
                    resource="ReportInstanceType"
                    placeholder={t('select_instance_type')}
                    display="name"
                    tag="name"
                    autoload
                  />
                </Col>
                <Col lg={6}>
                  <Editor name={`instances[${index}].query`} height="200" />
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <Calculations getFieldHelpers={getFieldHelpers} index={index} tags={tags} />
                </Col>
              </Row>
              <DataView index={index} />
            </CardBody>
          </Card>
        </Col>
      )}
    </Row>
  );
};

Index.propTypes = {
  index: PropTypes.number.isRequired
};

export default Index;
